import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import { Button, Image } from 'components/ui';
import { mediaQueries } from 'style/config';

/**
 * Venmo Pill Button - Release 4 Style
 * Renders as a pill-shaped button with Venmo logo
 */
const VenmoPill = props => {
    const { isVenmoEnabledForThisOrder, handleVenmoExpand } = props;

    // Don't render if Venmo is not enabled
    if (!isVenmoEnabledForThisOrder) {
        return null;
    }

    return (
        <Button
            variant='primary'
            onClick={handleVenmoExpand}
            data-at={Sephora.debug.dataAt('venmo_button')}
            aria-label='Pay with Venmo'
            css={styles}
            width={['100%', '151px', '100%']}
        >
            <Image
                src='/img/ufe/payments/no-border/venmo.svg'
                alt=''
                aria-hidden='true'
                height='12px'
            />
        </Button>
    );
};

const styles = {
    backgroundColor: '#008CFF',
    borderRadius: '22px',
    border: '0 solid #000',
    height: '44px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '10px 24px',
    gap: '12px',
    flexShrink: 0,
    [mediaQueries.xsMax]: {
        padding: '8px 16px'
    },
    '&:hover': {
        backgroundColor: '#1A9FFF'
    }
};

export default wrapFunctionalComponent(VenmoPill, 'VenmoPill');
